var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3V21H24V3H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15952_2064",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3V21H24V3H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15952_2064)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3V9H24V3H0Z",
    fill: "#FF8C1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15V21H24V15H0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9ZM12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9957 12.6455L11.3703 14.9508L11.7365 12.5904L10.2275 14.442L11.5221 12.4347L9.39046 13.5124L11.3897 12.2052L9.00391 12.3227L11.362 11.9417L9.13466 11.0787L11.4438 11.6897L9.76012 9.99535L11.6211 11.4927L10.7721 9.26008L11.8632 11.385L11.9957 9L12.1282 11.385L13.2193 9.26008L12.3703 11.4927L14.2313 9.99535L12.5476 11.6897L14.8568 11.0787L12.6295 11.9417L14.9875 12.3227L12.6018 12.2052L14.601 13.5124L12.4693 12.4347L13.7639 14.442L12.2549 12.5904L12.6212 14.9508L11.9957 12.6455Z",
    fill: "#3D58DB"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/india.008396ab309e8c2e854d4c119e42a5ed.svg";